import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-open-report-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" (click)="closed.emit()">
      <div class="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl dark:bg-gray-800" (click)="$event.stopPropagation()">

        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 mb-4">
          <svg class="w-6 h-6 text-blue-royal" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        </div>

        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Open report</h2>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
          This will move the report to your <strong>Reports</strong> page.
          You can find it there from now on.
        </p>

        <div class="mt-6 flex justify-end gap-2">
          <button type="button"
                  class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  (click)="closed.emit()">
            Cancel
          </button>
          <button type="button"
                  class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-500"
                  (click)="confirm.emit()">
            Open report
          </button>
        </div>

      </div>
    </div>
  `
})
export class OpenReportModalComponent {
  @Input() leadName = '';

  @Output() confirm = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }
}
